import {Pipe, PipeTransform} from '@angular/core';
import {DataMappingService} from '../services/data-mapping.service';
import {MitarbeiterBase} from '../dtos/mitarbeiterBase';

@Pipe({
  name: 'idToLaufnummer',
  standalone: false
})
export class IdToLaufnummerPipe implements PipeTransform {
  constructor(private readonly mapping: DataMappingService) {}

  transform(
    value: number | unknown,
    mitarbeiters?: MitarbeiterBase[]
  ): string | Promise<string> {
    if (value) {
      if (typeof value !== 'number') {
        throw Error(
          `The pipe input value has to be a number but was '${typeof value}'`
        );
      }
      if (mitarbeiters) {
        return this.mapping.mapMitarbeiterIdToLaufnummer(value, mitarbeiters);
      }
      // Fallback to async to load mitarbeiters in service
      return this.mapping.mapMitarbeiterIdToLaufnummerAsync(value);
    }
    return null;
  }
}
